import { config as deleteConfig } from './delete/config';
import { api as deleteApi } from './delete/api';
import { config as quickSubmitConfig } from './quick-submit/config';
import { api as quickSubmitApi } from './quick-submit/api';
import { config as addNotesConfig } from './add-notes/config';
import { api as addNotesApi } from './add-notes/api';
import { config as tagToJobConfig } from './tag-to-job/config';
import { api as tagToJobApi } from './tag-to-job/api';
import { config as changeStatusConfig } from './change-status/config';
import { api as changeStatusApi } from './change-status/api';
import { config as removeFromShortlistConfig } from './remove-from-shortlist/config';
import { api as removeFromShortlistApi } from './remove-from-shortlist/api';
import { config as addToGroupsConfig } from './add-to-groups/config';
import { api as addToGroupsApi } from './add-to-groups/api';
import { config as selfAssignConfig } from './self-assign/config';
import { api as selfAssignApi } from './self-assign/api';
import { config as othersAssignConfig } from './others-assign/config';
import { api as othersAssignApi } from './others-assign/api';
import { config as stickyNotesConfig } from './sticky-notes/config';
import { api as stickyNotesApi } from './sticky-notes/api';
import { config as moveToOnboardingConfig } from './move-to-onboarding/config';
import { api as moveToOnboardingApi } from './move-to-onboarding/api';
import { config as approveRateConfig } from './approve-rate/config';
import { api as approveRateApi } from './approve-rate/api';
import { config as managerApproveConfig } from './manager-approve/config';
import { api as managerApproveApi } from './manager-approve/api';
import { config as managerReapproveConfig } from './manager-reapprove/config';
import { api as managerReapproveApi } from './manager-reapprove/api';
import { config as rejectConfig } from './reject/config';
import { api as rejectApi } from './reject/api';

export const POPUP_CONFIGS = {
  'delete': deleteConfig,
  'quick-submit': quickSubmitConfig,
  'add-notes': addNotesConfig,
  'tag-to-job': tagToJobConfig,
  'change-status': changeStatusConfig,
  'remove-from-shortlist': removeFromShortlistConfig,
  'add-to-groups': addToGroupsConfig,
  'self-assign': selfAssignConfig,
  'others-assign': othersAssignConfig,
  'sticky-notes': stickyNotesConfig,
  'move-to-onboarding': moveToOnboardingConfig,
  'approve-rate': approveRateConfig,
  'manager-approve': managerApproveConfig,
  'manager-reapprove': managerReapproveConfig,
  'reject': rejectConfig,
};

const popupApiMap = {
  'delete': deleteApi,
  'quick-submit': quickSubmitApi,
  'add-notes': addNotesApi,
  'tag-to-job': tagToJobApi,
  'change-status': changeStatusApi,
  'remove-from-shortlist': removeFromShortlistApi,
  'add-to-groups': addToGroupsApi,
  'self-assign': selfAssignApi,
  'others-assign': othersAssignApi,
  'sticky-notes': stickyNotesApi,
  'move-to-onboarding': moveToOnboardingApi,
  'approve-rate': approveRateApi,
  'manager-approve': managerApproveApi,
  'manager-reapprove': managerReapproveApi,
  'reject': rejectApi,
};

export default popupApiMap;
